var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRenticBg404(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1060.9 756.79",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        opacity: .8;\n      }\n\n      .cls-2 {\n        fill: #4287f5;\n        stroke-width: 0px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "die_line",
    "data-name": "die line"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m194.5,286.45c0-25.34,2.36-63.07,3.54-88.41h-2.36c-12.38,22.4-28.29,44.79-41.85,67.19l-38.9,63.66h216.9v76.62H19.45v-70.73L163.85,115.52h124.95v373.68h-94.3v-202.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m383.1,300.59c0-127.9,59.53-192.14,147.35-192.14s147.35,64.24,147.35,192.14-59.53,195.68-147.35,195.68-147.35-67.78-147.35-195.68Zm205.11,0c0-93.12-26.52-114.34-57.76-114.34s-57.76,21.22-57.76,114.34,26.52,117.88,57.76,117.88,57.76-24.75,57.76-117.88Zm-104.91,0c0-28.29,20.04-47.15,47.15-47.15s47.15,18.86,47.15,47.15-20.04,47.15-47.15,47.15-47.15-18.86-47.15-47.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m901.77,286.45c0-25.34,2.36-63.07,3.54-88.41h-2.36c-12.38,22.4-28.29,44.79-41.85,67.19l-38.9,63.66h216.9v76.62h-312.38v-70.73l144.4-219.26h124.95v373.68h-94.3v-202.75Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRenticBg404);
export default __webpack_public_path__ + "static/media/rentic_bg_404.55607d651ae8a953a3ba2fcc8b624cf2.svg";
export { ForwardRef as ReactComponent };